
    <button [disabled]="!(enabled$ | async)"
        [matTooltip]="tooltip"
        (click)="onClick()"
        mat-icon-button
        type="button">
        <mat-icon>{{!isTypePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    